
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34648',
  depVersions: {
  "documents-public-ui": "static-1.34648",
  "atom": "static-1.5126",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2550",
  "client-types": "static-1.473",
  "cssUtils": "static-1.804",
  "customer-data-filters-ui": "static-1.39975",
  "customer-data-objects": "static-1.7727",
  "customer-data-property-utils": "static-1.8142",
  "documents-lib": "static-1.34653",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85991",
  "FormUrlGenerator": "static-2.4772",
  "foundations-theming-specialty": "static-1.2192",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5643",
  "hs-test-utils": "static-1.8068",
  "hub-http": "static-1.6274",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11832",
  "HubStyleTokens": "static-2.11525",
  "I18n": "static-7.1633",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3072",
  "jasmine-runner": "static-1.6515",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7207",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5450",
  "quartz": "static-1.7093",
  "react": "static-7.187",
  "react-dlb": "static-1.80",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16729",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5384",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8223",
  "reference-resolvers-lite": "static-1.8147",
  "reporting-data": "static-1.67774",
  "reporting-reports": "static-1.67452",
  "reporting-snowflake": "static-1.56392",
  "reporting-testing-lib": "static-1.9707",
  "reporting-visualizations": "static-1.59850",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8995",
  "sanitize": "static-1.4528",
  "sanitize-text": "static-1.8194",
  "self-service-api": "static-1.10298",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1799",
  "signup-constants": "static-1.18949",
  "signup-ui-url-generator": "static-2.8105",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4812",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4814",
  "ui-addon-form-validation": "static-1.11041",
  "ui-asset-management-lib": "static-1.11103",
  "ui-images": "static-2.1165",
  "UIComponents": "static-3.8471",
  "usage-tracker": "static-1.7401",
  "usage-tracker-container": "static-1.7391",
  "usage-tracker-core": "static-1.7251",
  "viral-links-lib": "static-1.7120",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9716",
  "foundations-components": "static-1.8028",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.871",
  "quartz-core": "static-1.6312",
  "quick-fetch": "static-1.3958",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4704",
  "ui-addon-i18n": "static-1.11203",
  "ui-addon-upgrades": "static-9.18067",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3440",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3370",
  "quartz-webpack": "static-1.3317",
  "foundations-assets": "static-1.4921",
  "foundations-theming": "static-1.4476",
  "hub-http-shared-msw-handlers": "static-1.10086",
  "hubspotter-http": "static-1.4691",
  "sassPrefix": "static-1.157",
  "events-data-lib": "static-1.279",
  "conversations-skeleton-state": "static-1.7300",
  "crm-message-bus": "static-1.43101",
  "customer-data-filters-ui-msw-helpers": "static-1.22410",
  "customer-data-objects-ui-components": "static-1.13082",
  "customer-data-reference-ui-components": "static-1.13219",
  "customer-data-ui-utilities": "static-1.9877",
  "framework-builder-read-service-client": "static-1.4045",
  "framework-data-schema-quick-fetch": "static-1.6844",
  "framework-data-schema-resolvers": "static-1.6939",
  "inbound-db-meta-service-client": "static-1.3626",
  "inbound-db-properties-service-client": "static-1.3886",
  "multi-account-reference-resolvers": "static-1.1032",
  "onboarding-tours": "static-1.16700",
  "reporting-datasets-permissions-lib": "static-1.13824",
  "ui-addon-teams": "static-1.21624",
  "quartz-auth": "static-1.768",
  "ui-business-units-lib": "static-1.9109",
  "usage-tracker-session-replay": "static-1.5087",
  "ai-components-ui-library": "static-1.9095",
  "ContentUtils": "static-1.68513",
  "customer-data-properties": "static-1.51746",
  "forms-ai-lib": "static-1.4395",
  "forms-utils-lib": "static-1.12678",
  "foundations-components-test-utils": "static-1.5511",
  "react-dnd-compat": "static-1.4665",
  "react-tinymce": "static-1.55385",
  "tinymce-config": "static-2.54511",
  "ui-gdpr-components": "static-1.10401",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3461",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3179",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.121",
  "ui-fonts": "static-1.787",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4377",
  "csstype": "static-1.50",
  "quartz-head": "static-1.758",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1593",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.768",
  "frontend-preferences-client": "static-1.7978",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3750",
  "reporting-client-types": "static-1.2525",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25524",
  "hubspot-apollo-client": "static-1.4929",
  "foundations-components-legacy": "static-1.1053",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.523",
  "hs-story-utils": "static-1.9475",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.278",
  "timezone-utils": "static-2.5295",
  "seat-types-lib": "static-1.136",
  "bend-plugin-foundations-components": "static-1.4297",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2073",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-test": "static-1.768",
  "quartz-tracking": "static-1.472",
  "bend-plugin-chirp-manifest": "static-1.114",
  "chirp-fetch": "static-1.1939",
  "purchase-motions-components": "static-1.6005",
  "salesImages": "static-1.526",
  "ts-schema": "static-1.4120",
  "bender-build-tools": "static-1.3254",
  "bend-plugin-foundations-theming": "static-1.2959",
  "stylex": "static-1.34",
  "hs-resources": "static-1.219",
  "pulse": "static-1.637",
  "restore-request-side-panel-lib": "static-1.1032",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3838",
  "crm-pipelines-api-client-types": "static-1.4180",
  "fdsr-migration-layer": "static-1.58",
  "multi-currency-client-types": "static-1.3732",
  "getting-started-shared-tasks": "static-1.18569",
  "growth-data-modal": "static-1.5507",
  "growth-onboarding-confetti": "static-1.3118",
  "growth-onboarding-next-action-utils": "static-1.2066",
  "navigation-components": "static-1.18165",
  "onboarding-tours-client": "static-1.4914",
  "onboarding-tours-utils": "static-1.766",
  "ui-shepherd-react": "static-3.10263",
  "ui-shepherd-tracker": "static-1.7644",
  "ui-universal-auth": "static-1.9040",
  "user-context": "static-1.5159",
  "hubspotter-http-shared-msw-handlers": "static-1.10084",
  "magpie-lib": "static-1.5585",
  "navigation-messaging": "static-1.7492",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21514",
  "copilot-toolkit": "static-1.11269",
  "cms-field-types": "static-1.4864",
  "content-icons-ui": "static-1.2239",
  "integrations-lib": "static-1.16327",
  "calling-global-api": "static-1.64688",
  "calling-internal-common": "static-1.31355",
  "calling-lifecycle-internal": "static-1.66070",
  "calling-lifecycle-messages": "static-1.58364",
  "commerce-products-lib": "static-1.9747",
  "crm-links": "static-1.6356",
  "customer-data-properties-shared-msw-handlers": "static-1.9413",
  "file-manager-components": "static-1.23754",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4263",
  "meetings-icalendar-utils-lib": "static-1.684",
  "object-builder-ui-client": "static-1.48918",
  "pipeline-validation-client-types": "static-1.4006",
  "property-value-citations": "static-1.2360",
  "smart-property-lib": "static-1.7370",
  "tiered-pricing": "static-1.1330",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9111",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19918",
  "tinymce-themes": "static-1.56481",
  "data-token-picker": "static-1.16493",
  "hub-http-contrib": "static-1.3093",
  "interframe": "static-3.4811",
  "tinymce-data": "static-1.40596",
  "tinymce-plugins": "static-1.57625",
  "ui-addon-sales-email": "static-1.5262",
  "onboarding-scopes": "static-1.6513",
  "ui-addon-opt": "static-4.8414",
  "apollo-link-hub-http": "static-2.4703",
  "hubspot-apollo-cache": "static-1.388",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.223",
  "purchase-motions-api": "static-1.6008",
  "event-emitter": "static-1.999",
  "bend-plugin-pulse": "static-1.140",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2040",
  "growth-onboarding-next-action-components": "static-1.2094",
  "user-context-client": "static-1.4655",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5045",
  "nest": "static-1.283",
  "reactive-lib": "static-1.775",
  "simple-logging-lib": "static-1.3102",
  "unified-auth-core-lib": "static-1.836",
  "getting-started-shared-tasks-store": "static-1.17687",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.832",
  "integrations-error-boundary-lib": "static-1.13742",
  "integrations-tracking-lib": "static-1.5654",
  "native-integrations-shared-strings": "static-1.7833",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10416",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.554",
  "calling-error-reporting": "static-1.31362",
  "shared-worker-versioning": "static-1.11088",
  "calling-usage-tracker": "static-1.6593",
  "voice-sms-access-library": "static-1.1204",
  "customer-data-tracking": "static-1.6941",
  "commerce-permissions": "static-1.825",
  "products-iframe-lib": "static-1.8076",
  "products-ui-components-shared-msw-handlers": "static-1.10468",
  "location-customization-utils-lib": "static-1.9408",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4205",
  "video-components-external": "static-1.11457",
  "video-data-lib": "static-1.35115",
  "data-agent-kit": "static-1.274",
  "feedback-loader": "static-1.29389",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10169",
  "fsm": "static-1.3782",
  "policy-lib": "static-1.6828",
  "react-colorpicker": "static-2.10260",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10232",
  "FileManagerLib": "static-1.39394",
  "NamespacedHubStyle": "static-2.9099",
  "FileManagerCore": "static-1.39253",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7829",
  "layout-dnd-components": "static-1.12541",
  "layout-dnd-utils": "static-1.11516",
  "react-codemirror": "static-1.10679",
  "ui-addon-emoji-picker": "static-1.9938",
  "ui-brand-identity-lib": "static-1.15478",
  "InboxConnectUtils": "static-4.14954",
  "meetings-connect-utils-lib": "static-1.7656",
  "breeze-engine-core": "static-1.110",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3067",
  "ads-unified-auth-lib": "static-1.26",
  "google-sheets-integration-lib": "static-1.385",
  "microsoft-drive-integration-lib": "static-1.519",
  "slack-ui-library": "static-1.10443",
  "calling-orchestration-schema": "static-1.35981",
  "sales-views-client-types": "static-1.4309",
  "crm-record-cards-service-types": "static-1.3630",
  "content-media-composition-data-lib": "static-1.12524",
  "content-media-compositions": "static-2.16531",
  "media-bridge-lib": "static-1.19016",
  "trellis-story-utils": "static-1.4565",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.5992",
  "FileManagerImages": "static-1.36905",
  "video-components": "static-1.13459",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4589",
  "video-embed": "static-1.35949",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8755",
  "ui-coaching-tips": "static-1.28702",
  "ContentData": "static-1.68588",
  "layout-data-lib": "static-1.9841",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22239",
  "outpost": "static-1.4228",
  "growth-onboarding-feedback-components": "static-1.6631",
  "advanced-menus-core": "static-1.15207",
  "advanced-menus-lib": "static-1.12143",
  "ExportDialog": "static-6.10437",
  "ui-memberships-settings-lib": "static-1.34184",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15206",
  "simple-menus-lib": "static-1.16723"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34648",
  "atom": "/atom/static-1.5126",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2550",
  "client-types": "/client-types/static-1.473",
  "cssUtils": "/cssUtils/static-1.804",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39975",
  "customer-data-objects": "/customer-data-objects/static-1.7727",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8142",
  "documents-lib": "/documents-lib/static-1.34653",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85991",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4772",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2192",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5643",
  "hs-test-utils": "/hs-test-utils/static-1.8068",
  "hub-http": "/hub-http/static-1.6274",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11525",
  "I18n": "/I18n/static-7.1633",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3072",
  "jasmine-runner": "/jasmine-runner/static-1.6515",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7207",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5450",
  "quartz": "/quartz/static-1.7093",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16729",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5384",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8223",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8147",
  "reporting-data": "/reporting-data/static-1.67774",
  "reporting-reports": "/reporting-reports/static-1.67452",
  "reporting-snowflake": "/reporting-snowflake/static-1.56392",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9707",
  "reporting-visualizations": "/reporting-visualizations/static-1.59850",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8995",
  "sanitize": "/sanitize/static-1.4528",
  "sanitize-text": "/sanitize-text/static-1.8194",
  "self-service-api": "/self-service-api/static-1.10298",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1799",
  "signup-constants": "/signup-constants/static-1.18949",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8105",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4812",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4814",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11041",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11103",
  "ui-images": "/ui-images/static-2.1165",
  "UIComponents": "/UIComponents/static-3.8471",
  "usage-tracker": "/usage-tracker/static-1.7401",
  "usage-tracker-container": "/usage-tracker-container/static-1.7391",
  "usage-tracker-core": "/usage-tracker-core/static-1.7251",
  "viral-links-lib": "/viral-links-lib/static-1.7120",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9716",
  "foundations-components": "/foundations-components/static-1.8028",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.871",
  "quartz-core": "/quartz-core/static-1.6312",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4704",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11203",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18067",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3370",
  "quartz-webpack": "/quartz-webpack/static-1.3317",
  "foundations-assets": "/foundations-assets/static-1.4921",
  "foundations-theming": "/foundations-theming/static-1.4476",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10086",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "sassPrefix": "/sassPrefix/static-1.157",
  "events-data-lib": "/events-data-lib/static-1.279",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7300",
  "crm-message-bus": "/crm-message-bus/static-1.43101",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22410",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13082",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13219",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9877",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6844",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6939",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1032",
  "onboarding-tours": "/onboarding-tours/static-1.16700",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13824",
  "ui-addon-teams": "/ui-addon-teams/static-1.21624",
  "quartz-auth": "/quartz-auth/static-1.768",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9109",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5087",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9095",
  "ContentUtils": "/ContentUtils/static-1.68513",
  "customer-data-properties": "/customer-data-properties/static-1.51746",
  "forms-ai-lib": "/forms-ai-lib/static-1.4395",
  "forms-utils-lib": "/forms-utils-lib/static-1.12678",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5511",
  "react-dnd-compat": "/react-dnd-compat/static-1.4665",
  "react-tinymce": "/react-tinymce/static-1.55385",
  "tinymce-config": "/tinymce-config/static-2.54511",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10401",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3461",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3179",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "ui-fonts": "/ui-fonts/static-1.787",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4377",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.758",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1593",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.768",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7978",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3750",
  "reporting-client-types": "/reporting-client-types/static-1.2525",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25524",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4929",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1053",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.523",
  "hs-story-utils": "/hs-story-utils/static-1.9475",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.278",
  "timezone-utils": "/timezone-utils/static-2.5295",
  "seat-types-lib": "/seat-types-lib/static-1.136",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4297",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2073",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-test": "/quartz-test/static-1.768",
  "quartz-tracking": "/quartz-tracking/static-1.472",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.114",
  "chirp-fetch": "/chirp-fetch/static-1.1939",
  "purchase-motions-components": "/purchase-motions-components/static-1.6005",
  "salesImages": "/salesImages/static-1.526",
  "ts-schema": "/ts-schema/static-1.4120",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2959",
  "stylex": "/stylex/static-1.34",
  "hs-resources": "/hs-resources/static-1.219",
  "pulse": "/pulse/static-1.637",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.58",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18569",
  "growth-data-modal": "/growth-data-modal/static-1.5507",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3118",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2066",
  "navigation-components": "/navigation-components/static-1.18165",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4914",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.766",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10263",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7644",
  "ui-universal-auth": "/ui-universal-auth/static-1.9040",
  "user-context": "/user-context/static-1.5159",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10084",
  "magpie-lib": "/magpie-lib/static-1.5585",
  "navigation-messaging": "/navigation-messaging/static-1.7492",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21514",
  "copilot-toolkit": "/copilot-toolkit/static-1.11269",
  "cms-field-types": "/cms-field-types/static-1.4864",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "integrations-lib": "/integrations-lib/static-1.16327",
  "calling-global-api": "/calling-global-api/static-1.64688",
  "calling-internal-common": "/calling-internal-common/static-1.31355",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66070",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58364",
  "commerce-products-lib": "/commerce-products-lib/static-1.9747",
  "crm-links": "/crm-links/static-1.6356",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9413",
  "file-manager-components": "/file-manager-components/static-1.23754",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4263",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.684",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48918",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4006",
  "property-value-citations": "/property-value-citations/static-1.2360",
  "smart-property-lib": "/smart-property-lib/static-1.7370",
  "tiered-pricing": "/tiered-pricing/static-1.1330",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9111",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19918",
  "tinymce-themes": "/tinymce-themes/static-1.56481",
  "data-token-picker": "/data-token-picker/static-1.16493",
  "hub-http-contrib": "/hub-http-contrib/static-1.3093",
  "interframe": "/interframe/static-3.4811",
  "tinymce-data": "/tinymce-data/static-1.40596",
  "tinymce-plugins": "/tinymce-plugins/static-1.57625",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5262",
  "onboarding-scopes": "/onboarding-scopes/static-1.6513",
  "ui-addon-opt": "/ui-addon-opt/static-4.8414",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4703",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.388",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.223",
  "purchase-motions-api": "/purchase-motions-api/static-1.6008",
  "event-emitter": "/event-emitter/static-1.999",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.140",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2040",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2094",
  "user-context-client": "/user-context-client/static-1.4655",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5045",
  "nest": "/nest/static-1.283",
  "reactive-lib": "/reactive-lib/static-1.775",
  "simple-logging-lib": "/simple-logging-lib/static-1.3102",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.836",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17687",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.832",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13742",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5654",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7833",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10416",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.554",
  "calling-error-reporting": "/calling-error-reporting/static-1.31362",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11088",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6593",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1204",
  "customer-data-tracking": "/customer-data-tracking/static-1.6941",
  "commerce-permissions": "/commerce-permissions/static-1.825",
  "products-iframe-lib": "/products-iframe-lib/static-1.8076",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10468",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9408",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4205",
  "video-components-external": "/video-components-external/static-1.11457",
  "video-data-lib": "/video-data-lib/static-1.35115",
  "data-agent-kit": "/data-agent-kit/static-1.274",
  "feedback-loader": "/feedback-loader/static-1.29389",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10169",
  "fsm": "/fsm/static-1.3782",
  "policy-lib": "/policy-lib/static-1.6828",
  "react-colorpicker": "/react-colorpicker/static-2.10260",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10232",
  "FileManagerLib": "/FileManagerLib/static-1.39394",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
  "FileManagerCore": "/FileManagerCore/static-1.39253",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7829",
  "layout-dnd-components": "/layout-dnd-components/static-1.12541",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11516",
  "react-codemirror": "/react-codemirror/static-1.10679",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9938",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15478",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14954",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7656",
  "breeze-engine-core": "/breeze-engine-core/static-1.110",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3067",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.26",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.385",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.519",
  "slack-ui-library": "/slack-ui-library/static-1.10443",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35981",
  "sales-views-client-types": "/sales-views-client-types/static-1.4309",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12524",
  "content-media-compositions": "/content-media-compositions/static-2.16531",
  "media-bridge-lib": "/media-bridge-lib/static-1.19016",
  "trellis-story-utils": "/trellis-story-utils/static-1.4565",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.5992",
  "FileManagerImages": "/FileManagerImages/static-1.36905",
  "video-components": "/video-components/static-1.13459",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4589",
  "video-embed": "/video-embed/static-1.35949",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8755",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28702",
  "ContentData": "/ContentData/static-1.68588",
  "layout-data-lib": "/layout-data-lib/static-1.9841",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22239",
  "outpost": "/outpost/static-1.4228",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6631",
  "advanced-menus-core": "/advanced-menus-core/static-1.15207",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12143",
  "ExportDialog": "/ExportDialog/static-6.10437",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34184",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15206",
  "simple-menus-lib": "/simple-menus-lib/static-1.16723"
}
};
